import { useQuery } from '@tanstack/react-query';
import { Badge } from '../../../components/ui';
import { formatDateTime, humanise } from '../../../lib/format';
import { recentDecisionsQuery } from '../queries';
import {
  RowTitle,
  WidgetCard,
  WidgetEmpty,
  WidgetError,
  WidgetList,
  WidgetRow,
  WidgetSkeleton,
} from '../primitives';

/** What quality has decided lately, and on what basis. */
export function RecentDecisionsWidget({ limit = 5, to }: { limit?: number; to?: string }) {
  const query = useQuery(recentDecisionsQuery);
  const rows = (query.data?.items ?? []).slice(0, limit);

  return (
    <WidgetCard
      title="Recent decisions"
      description="Every release and rejection is attributed and kept."
      to={to}
      toLabel="Full queue"
    >
      {query.isPending ? <WidgetSkeleton rows={2} /> : null}
      {query.isError ? (
        <WidgetError label="Could not load decisions." onRetry={() => void query.refetch()} />
      ) : null}
      {query.isSuccess && rows.length === 0 ? (
        <WidgetEmpty>No decisions recorded yet.</WidgetEmpty>
      ) : null}
      {rows.length > 0 ? (
        <WidgetList>
          {rows.map((check) => (
            <WidgetRow key={check.id}>
              <RowTitle
                title={check.lotCode}
                subtitle={
                  <>
                    <span className="font-mono">{check.itemCode}</span> ·{' '}
                    {check.checkedByName ?? '—'} · {formatDateTime(check.checkedAt)}
                  </>
                }
              />
              <Badge tone={check.status === 'passed' ? 'green' : 'muted'}>
                {humanise(check.status)}
              </Badge>
            </WidgetRow>
          ))}
        </WidgetList>
      ) : null}
    </WidgetCard>
  );
}
